import spartaStyleUtility from "utilities/global/sparta-style-utility/3.2.4/js/sparta-style-utility";



class LoadingSpinner {



  constructor() {
    this.PAGE_LEVEL_FREEZE = 'loading-spinner-page-level-freeze';
    this.PAGE_LEVEL_BODY = 'loading-spinner-page-level-body';
    this.CLASSNAME = 'loading-spinner-container';
  }







  add(el, text = null) {
    el.innerHTML = this.spinnerTpl(text);
  }






  remove(el) {
    const container = el.querySelector(`.${this.CLASSNAME}`);
    return new Promise((resolve) => {
      if (container) {
        container.classList.remove('LSU_fadeIn');
        container.classList.add('LSU_fadeOut');
        setTimeout(() => {
          el.innerHTML = '';
          resolve();
        }, 500);
      } else {
        resolve();
      }
    });
  }







  pageLevel(show = true, text = '') {
    const body = document.querySelector('body');
    return this.blockingSpinner(body, show, text);
  }









  moduleLevel(target, show = true, text = '', fadeIn = true) {
    return this.blockingSpinner(target, show, text, fadeIn);
  }









  async blockingSpinner(target, show, text = '', fadeIn = true) {
    if (show) {
      const tpl = this.spinnerTpl(text, this.PAGE_LEVEL_BODY, fadeIn);
      const el = document.querySelector(`.${this.PAGE_LEVEL_BODY}`);

      target.classList.add(this.PAGE_LEVEL_FREEZE);
      if (!el) {
        target.insertAdjacentHTML('beforeend', tpl);
      }
    } else {
      const el = target.querySelector(`.${this.PAGE_LEVEL_BODY}`);

      if (el) {
        return this.remove(el)
          .then(() => {
            try {
              target.classList.remove(this.PAGE_LEVEL_FREEZE);
              target.removeChild(el);
            } catch (error) {
              console.warn('Loading Spinner Utility - no spinner to remove ', target, error);
            }
          });
      }
    }
  }








  spinnerTpl(text, cls = '', fadeIn = true) {
    const animations = (fadeIn ? ' LSU_fadeIn' : '');
    return `
  <div class="${cls}">
  <div class="${this.CLASSNAME}${animations} LSU_animated">
     <div class="loading-spinner"></div>
     ${text ? `<div class="text-content">${text}</div>` : ''}
  </div>
  </div>
  `;
  }
}

export default new LoadingSpinner();
